import type { GetMeUserResponse } from "@nlc/shared-types";
import type { QueryClient } from "@tanstack/react-query";

import { UserRoleEnum } from "@nlc/shared-types";
import { redirect } from "@tanstack/react-router";
import posthog from "posthog-js";
import { useFeatureFlagEnabled } from "posthog-js/react";

import { env } from "@/config/env";
import { waitForPostHogFlags } from "@/lib/posthog-flags";

export const SUBSCRIPTION_MANAGEMENT_FLAG = "subscription-management";

export const isSubscriptionManagementEnabled =
  env.VITE_SENTRY_ENVIRONMENT !== "prod";

export const BILLING_ROUTES = {
  overview: "/billing",
} as const;

export async function requireSubscriptionManagement(): Promise<void> {
  if (isSubscriptionManagementEnabled) {
    return;
  }

  await waitForPostHogFlags();

  if (!posthog.isFeatureEnabled(SUBSCRIPTION_MANAGEMENT_FLAG)) {
    throw redirect({ to: "/requests" });
  }
}

export function useSubscriptionManagementEnabled(): boolean {
  const isFlagged = useFeatureFlagEnabled(SUBSCRIPTION_MANAGEMENT_FLAG);

  return isSubscriptionManagementEnabled || isFlagged === true;
}

export function requireSubscriptionOwner(queryClient: QueryClient): void {
  const user = queryClient.getQueryData<GetMeUserResponse>(["user"]);

  if (user?.user.roleId !== UserRoleEnum.Owner) {
    throw redirect({ to: "/requests" });
  }
}
